"use strict";
var anObject = require("../internals/an-object");
var ordinaryToPrimitive = require("../internals/ordinary-to-primitive");
var $TypeError = TypeError;
module.exports = function(hint) {
  anObject(this);
  if (hint === "string" || hint === "default") hint = "string";
  else if (hint !== "number") throw new $TypeError("Incorrect hint");
  return ordinaryToPrimitive(this, hint);
};
